module.exports = __webpack_public_path__ + "img/solution-v2x-function-pic.c41dcd0f.png";